
import axios from "axios";

const api = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/api/admin`,
});

/**
 * Fetch all inventory items (products + raw materials)
 */
export const getUnifiedInventory = async (token) => {
    if (!token) throw new Error("JWT token missing.");
    try {
        const response = await api.get("/inventory/all", {
            headers: { Authorization: `Bearer ${token}` },
        });
        return Array.isArray(response.data) ? response.data : [];
    } catch (err) {
        console.error("Error fetching unified inventory:", err.response?.data || err.message);
        throw err;
    }
};

/**
 * Fetch all products with inventory
 */
export const getInventory = async (token) => {
    if (!token) throw new Error("JWT token missing.");

    try {
        const response = await api.get("/inventory", {
            headers: { Authorization: `Bearer ${token}` },
        });

        return Array.isArray(response.data) ? response.data : [];
    } catch (err) {
        console.error("Error fetching inventory:", err.response?.data || err.message);
        throw err;
    }
};

/**
 * Update inventory quantity
 */
export const updateInventory = async (productId, quantityChange, token, branchId = null) => {
    if (!token) throw new Error("JWT token missing.");

    try {
        const response = await api.put(
            `/inventory/${productId}`,
            { quantityChange, branch_id: branchId },
            { headers: { Authorization: `Bearer ${token}` } }
        );

        return response.data;
    } catch (err) {
        console.error("Error updating inventory:", err.response?.data || err.message);
        throw err;
    }
};

/**
 * Update raw material inventory quantity
 */
export const updateRawMaterialInventory = async (rawMaterialId, quantityChange, token) => {
    if (!token) throw new Error("JWT token missing.");

    try {
        const response = await api.put(
            `/raw-materials/${rawMaterialId}/inventory`,
            { quantityChange },
            { headers: { Authorization: `Bearer ${token}` } }
        );

        return response.data;
    } catch (err) {
        console.error("Error updating raw material inventory:", err.response?.data || err.message);
        throw err;
    }
};

/**
 * Release stock from admin inventory to a branch
 */
export const releaseInventoryToBranch = async ({ product_id, raw_material_id, branch_id, qty, remarks }, token) => {
    if (!token) throw new Error("JWT token missing.");

    try {
        const response = await api.post(
            `/inventory/release`,
            { product_id, raw_material_id, branch_id, qty, remarks },
            { headers: { Authorization: `Bearer ${token}` } }
        );
        return response.data;
    } catch (err) {
        console.error("Error releasing inventory to branch:", err.response?.data || err.message);
        throw err;
    }
};

/**
 * Set released stock quantity for a specific branch inventory row
 */
export const adjustReleasedInventoryToBranch = async ({ product_id, raw_material_id, branch_id, released_qty }, token) => {
    if (!token) throw new Error("JWT token missing.");

    try {
        const response = await api.post(
            `/inventory/release/adjust`,
            { product_id, raw_material_id, branch_id, released_qty },
            { headers: { Authorization: `Bearer ${token}` } }
        );
        return response.data;
    } catch (err) {
        console.error("Error adjusting released inventory:", err.response?.data || err.message);
        throw err;
    }
};
